export default {"src":"/login/_next/static/media/favicon.7bdcca20.ico","height":32,"width":32,"blurWidth":0,"blurHeight":0};